import React from 'react';
import { Toaster } from 'sonner';

const Notification = () => {
  return (
    <Toaster
      position="top-center"
      richColors
      closeButton
      duration={5000}
      pauseWhenPageIsHidden
      toastOptions={{
        classNames: {
          toast: 'rounded-xl shadow-md',
          title: 'text-sm font-normal',
          description: 'text-sm',
          closeButton: 'bg-transparent hover:bg-gray-100',
        },
      }}
    />
  );
};

export default Notification;
